import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { taskStatusService } from '@services';

export const useTaskStatuses = (projectId, options = {}) => {
  return useQuery({
    queryKey: ['taskStatuses', projectId],
    queryFn: () => taskStatusService.getAll(projectId),
    enabled: !!projectId,
    staleTime: 0, // Always refetch to ensure order is correct
    ...options,
  });
};

export const useCreateTaskStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: taskStatusService.create,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['taskStatuses', variables.projectId] });
    },
  });
};

export const useUpdateTaskStatusConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => taskStatusService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['taskStatuses'] });
    },
  });
};

export const useDeleteTaskStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: taskStatusService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['taskStatuses'] });
    },
  });
};

export const useReorderTaskStatuses = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ projectId, statusIds }) => taskStatusService.reorder(projectId, statusIds),
    onSuccess: (response, variables) => {
      // Update cache with new ordered data from server
      queryClient.setQueryData(['taskStatuses', variables.projectId], response);
      queryClient.invalidateQueries({ queryKey: ['taskStatuses', variables.projectId] });
    },
  });
};
